import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cart-loader"
}
const _hoisted_2 = { class: "cart-widget__headline" }
const _hoisted_3 = { class: "row g-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col align-self-center cart-widget__headline-label" }, " Dein Warenkorb ", -1)
const _hoisted_5 = { class: "col-auto align-self-center cart-widget__headline-close" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Warenkorb schließen ", -1)
const _hoisted_7 = { key: 1 }

import {
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import CartOverview from '@/components/cart/CartOverview.vue';
import CartItems from '@/components/cart/CartItems.vue';
import CartItemRemove from '@/components/cart/CartItemRemove.vue';
import Product from '@/classes/Product';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

library.add(faSpinner);
library.add(faTimes);

const store = useStore();
const router = useRouter();
const root = ref<InstanceType<typeof HTMLElement>>();
const content = ref<InstanceType<typeof HTMLElement>>();
const overview = ref<InstanceType<typeof CartOverview>>();

const setPosAndHeight = () => {
  if (root.value) {
    const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
    const $header = document.querySelector('header') as HTMLElement;

    let top = 0;
    if ($wpAdminBar) top += $wpAdminBar.scrollHeight;
    if ($header) top += $header.offsetHeight;

    root.value.style.top = `${top}px`;
    const widgetHeight = window.innerHeight - top;
    root.value.style.height = `${widgetHeight}px`;

    if (content.value && overview.value && overview.value.root) {
      const contentHeight = widgetHeight - overview.value.root.scrollHeight;
      content.value.style.height = `${contentHeight}px`;
    } else if (content.value) {
      content.value.style.height = `${widgetHeight}px`;
    }
  }
};

onMounted(() => {
  window.addEventListener('resize', setPosAndHeight);
  window.addEventListener('load', setPosAndHeight);
  setPosAndHeight();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(setPosAndHeight, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setPosAndHeight);
  window.removeEventListener('load', setPosAndHeight);
});

const itemToRemove = ref<Product | null>(null);
const keyToRemove = ref<string | null>(null);

const toggle = () => {
  store.commit('cart/TOGGLE_SHOW_WIDGET');
};

const show = computed(() => store.getters['cart/showWidget']);
const isLoading = computed(() => store.getters['cart/isLoading']);
const countItemsAll = computed(() => store.getters['cart/countAll']);
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');
const isOrderCancel = computed(() => countItemsAll.value === 1 && isOrderPage.value);
const orderIsCanceled = computed(() => countItemsAll.value === 0 && isOrderPage.value);

const onItemRemove = (key: string, product: Product) => {
  itemToRemove.value = product;
  keyToRemove.value = key;
};

const onRemoveDecline = () => {
  itemToRemove.value = null;
  keyToRemove.value = null;
};

const onRemoveApproved = () => {
  if (orderIsCanceled.value) {
    router.push('/');
    toggle();
  }
  onRemoveDecline();
};

watch(() => show.value, () => {
  if (!show.value) {
    setTimeout(() => {
      itemToRemove.value = null;
      keyToRemove.value = null;
    }, 475);
  }
});

watch(() => countItemsAll.value, () => {
  setTimeout(setPosAndHeight, 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "cart-widget",
    ref: (_value, _refs) => {
      _refs['root'] = _value
      root.value = _value
    },
    class: _normalizeClass({ show: _unref(show) })
  }, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: "fa-light fa-spinner",
              class: "fa-pulse"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref: (_value, _refs) => {
        _refs['content'] = _value
        content.value = _value
      },
      class: "cart-widget__content"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              title: "Warenkorb schließen",
              onClick: toggle
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-times" }),
              _hoisted_6
            ])
          ])
        ])
      ]),
      (itemToRemove.value)
        ? (_openBlock(), _createBlock(CartItemRemove, {
            key: 0,
            product: itemToRemove.value,
            "is-order-cancel": _unref(isOrderCancel),
            "item-key": keyToRemove.value,
            onClear: onRemoveDecline,
            onApproved: onRemoveApproved
          }, null, 8, ["product", "is-order-cancel", "item-key"]))
        : _createCommentVNode("", true),
      (_unref(countItemsAll) === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Dein Warenkorb ist leer "))
        : _createCommentVNode("", true),
      (!itemToRemove.value)
        ? (_openBlock(), _createBlock(CartItems, {
            key: 2,
            onRemove: onItemRemove
          }))
        : _createCommentVNode("", true)
    ], 512),
    (_unref(countItemsAll) > 0)
      ? (_openBlock(), _createBlock(CartOverview, {
          key: 1,
          ref: (_value, _refs) => {
            _refs['overview'] = _value
            overview.value = _value
          },
          onClose: toggle
        }, null, 512))
      : _createCommentVNode("", true)
  ], 2))
}
}

})